import {
  NPS_HANDLE_SUCCESS,
  NPS_HANDLE_FAILURE,
  SUBMIT_NPS_SUCCESS,
} from "../action/types";

const INIT_STATE = {
  showPopup: null,
  reason: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case NPS_HANDLE_SUCCESS:
      return {
        ...state,
        showPopup: action.payload?.showPopup ?? false,
        reason: action.payload?.reason ?? null,
      };
    case SUBMIT_NPS_SUCCESS:
      return {
        ...state,
        showPopup: false,
      };
    case NPS_HANDLE_FAILURE:
      return { ...state, showPopup: false };
    default:
      return state;
  }
};
